<template>
  <fieldset class="button-switch" :class="{open: open}">
    <button
      :class="'opener btn ' + classname"
      @click="open=!open"
      >{{ current }}
      &nbsp;
      <i><Icon name="triangle" /></i>
    </button>
    <label v-for="(label, option) in normalized">
      <input type="radio" v-model=check :value=option />
      <span
        :class="'btn ' + (value == option ? ' ' : 'inverse ') + classname"
      >
        {{ label }}
    </span>
    </label>
  </fieldset>
</template>

<script>
  export default {
    name: 'ButtonSwitch',
    props: {
      value: {required: true},
      options: {required: false, default: null},
      classname: {required: false, default: ''},
    },
    data () {return {
      check: this.value,
      open: false,
    }},
    watch: {
      check () {
        var value = this.check;
        if (!isNaN(Number(value))) {
          value = Number(value);
        }
        this.$emit('input', value);
      }
    },
    computed: {
      current () {
        if (this.normalized.hasOwnProperty(this.value)) {
          return this.normalized[this.value];
        }
        return this.$t('buttons.select');
      },
      normalized () {
        var options = this.options;
        if (options === null) {
          options = {
            0: this.$t('no'),
            1: this.$t('yes'),
          };
        }
        if (Array.isArray(options)) {
          var opts = {};
          for (let opt of options) {
            opts[opt.id] = opt.name;
          }
          return opts;
        }
        return options;
      }
    }
  }
</script>

<style scoped lang="scss">
  fieldset {
    display: inline;
    border: none;
    margin: 0;
    font-size: 0;
    .opener {
      margin: 0;
      @media (min-width: $sm-min) {
        display: none !important;
      }
      > i {
        display: inline-block;
        transform: scaleY(-1);
      }
    }
    label {
      display: inline-block;
      @media (max-width: $xs-max) {
        display: none;
      }
      margin: 10px 10px 0;
      input {
        display: none;
      }
    }
    @media (max-width: $xs-max) {
      &.open {
        position: relative;
        .opener > i {
          transform: none;
        }
        label {
          display: block !important;
          margin-left: 0;
          margin-right: 0;
          position: absolute;
          z-index: 500;
          left: 0;
          right: 0;
          @for $i from 1 through 10 {
            &:nth-of-type(#{$i}) {
              top: #{100% * $i};
            }
          }
        }
      }
    }
    .btn {
      opacity: 1;
      cursor: default;
      @media (max-width: $xs-max) {
        display: block;
      }
      &.inverse {
        cursor: pointer;
      }
    }
    &.tags {
      @include clearfix;
      label {
        display: inline-block;
        float: left;
        margin: 0;
        .btn {
          margin: 0 1px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/helpers/components/interact/ButtonSwitch.vue